import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Load notification test utilities in development
if (process.env.NODE_ENV === 'development') {
  import('./utils/testNotifications');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);